export default __webpack_public_path__ + "static/media/img-0617-monaco-full-face.64d404fc.png";